module.exports = __webpack_public_path__ + "static/media/goldTests.46dd1b61.png";